/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Monday , March 7th 2022, 10:10:07 am          #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */


import React, { useEffect, useState } from "react"
import {
    Col,
    Row,
    Button,
    Label
} from "reactstrap"

//**Importing required componant files   */
import DPDropDown from "framework/components/DPDropDown"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import { DecimalValidation, Numeric } from "framework/validators/TextValidation"

//**End Importing required componant files */

const PromotionDetailsContent = ({
    setProDetailsTable,
    dtFreeIssueIncreQty,
    SetdtFreeIssueIncreQty,
    dtIncrementalDiscount,
    SetdtIncrementalDiscount,
    dtDiscountAmount,
    SetdtDiscountAmount,
    dtIncrementalValue,
    SetdtIncrementalValue,
    dtMaxValue,
    SetdtMaxValue,
    dtMinValue,
    SetdtMinValue,
    dtTicket,
    SetdtTicket,
    dtFreeIssueQty,
    SetdtFreeIssueQty,
    dtIncrementDescPer,
    SetdtIncrementDescPer,
    dtDiscPer,
    SetdtDiscPer,
    dtIncrementQty,
    SetdtIncrementQty,
    dtMaxQty,
    SetdtMaxQty,
    dtMinQty,
    SetdtMinQty,
    disabled,
    VOUVALUE,
    VOUQTY,
    INCVOUQTY,
    POINTS,
    INCPOINTS,
    INCTICKQTY,
    setVOUVALUE,
    setVOUQTY,
    setINCVOUQTY,
    setPOINTS,
    setINCPOINTS,
    setINCTICKQTY,
    SetdtFreeIssueIncreQtyOnBlur,
    SetdtIncrementalDiscountOnBlur,
    SetdtDiscountAmountOnBlur,
    SetdtIncrementalValueOnBlur,
    SetdtMaxValueOnBlur,
    SetdtMinValueOnBlur,
    SetdtTicketOnBlur,
    SetdtFreeIssueQtyOnBlur,
    SetdtIncrementDescPerOnBlur,
    SetdtDiscPerOnBlur,
    SetdtIncrementQtyOnBlur,
    SetdtMaxQtyOnBlur,
    SetdtMinQtyOnBlur,
    setVOUVALUEOnBlur,
    setVOUQTYOnBlur,
    setINCVOUQTYOnBlur,
    setPOINTSOnBlur,
    setINCPOINTSOnBlur,
    setINCTICKQTYOnBlur,
    groupBundle,
    setGroupBundle,
    setItemBundle,
    itemBundle,
    setINCROUNDS,
    INCROUNDS,
    setINCROUNDSOnBlur,
    allSkubundles,
    allSKUGrpBundles,
    showAllFields,
    pskubidAct,
    grpbidAct,
    diskperAct,
    diskamtAct,
    fskbidAct,
    ticketAct,
    vouAct,
    pointAct,
    freeItemOnchange,
    freeIssueItem,
    ProDetailsTable,
    TicketSet,
    Ticket,
    setTicket,
    ticketValue
}) => {

    const [disbleQty, setdisbleQty] = useState(false)
    const [disbleValue, setdisbleValue] = useState(false)

    useEffect(() => {

        const hasProDetails = ProDetailsTable.length > 0;

        const isQtyFromToSet = hasProDetails && ProDetailsTable.some(item => parseFloat(item.QtyFrom) !== 0 || parseFloat(item.QtyTo) !== 0);
        const isValueFromToSet = hasProDetails && ProDetailsTable.some(item => parseFloat(item.ValueFrom) !== 0 || parseFloat(item.ValueTo) !== 0);

        const isMinQtyMaxQtySet = parseFloat(dtMinQty) !== 0 || parseFloat(dtMaxQty) !== 0;
        const isMinValueMaxValueSet = parseFloat(dtMinValue) !== 0 || parseFloat(dtMaxValue) !== 0;

        setdisbleValue(isQtyFromToSet || isMinQtyMaxQtySet);
        setdisbleQty(isValueFromToSet || isMinValueMaxValueSet);

    }, [dtMinValue, dtMaxValue, dtMinQty, dtMaxQty, ProDetailsTable])


    //disable object 
    const disableList = {
        Quantity: disbleQty,
        Value: disbleValue,
        DiscountPercentage: diskperAct ? false : true,
        DiscountAmount: diskamtAct ? false : true,
        FreeQty: fskbidAct ? false : true,
        Voucher: vouAct ? false : true,
        Ticket: ticketAct ? false : true,
        TicketValue: ticketValue ? false : true,
        Point: pointAct ? false : true,

    }


    function IncrementalCreate() {
        //SetDatatable([])

        var minQty = dtMinQty
        var maxQty = dtMaxQty
        var minVal = dtMinValue
        var maxVal = dtMaxValue
        var freeQty = dtFreeIssueQty
        var freeVouQty = VOUQTY
        var freeVouVal = VOUVALUE
        var ticket = dtTicket
        var points = POINTS
        var incQty = dtIncrementQty
        var incValue = dtIncrementalValue
        var incDiscPer = dtDiscPer
        var incDiscAmount = parseFloat(dtDiscountAmount).toFixed(2)
        var incFreeQty = dtFreeIssueQty
        var incTickrtQty = dtTicket
        var incVoucherQty = VOUQTY
        var incPoints = POINTS
        var rounds = parseInt(INCROUNDS)

        var newTable = []



        for (let i = 0; i <= rounds; i++) {
            newTable.push({
                "id": i + 1,
                "QtyFrom": minQty,
                "QtyTo": maxQty,
                "ValueFrom": parseFloat(minVal).toFixed(2),
                "ValueTo": parseFloat(maxVal).toFixed(2),
                "DiscPer": parseFloat(incDiscPer).toFixed(2),
                "DiscValue": parseFloat(incDiscAmount).toFixed(2),
                "freeQty": incFreeQty,
                "TicketQty": incTickrtQty,
                "VoucherQty": incVoucherQty,
                "VoucherValue": freeVouVal,
                "Points": incPoints,
                "validQty": 0,
                "OfferBun": itemBundle,
                "GroupBun": itemBundle,
                "FreeItem": allSkubundles,
            })

            if (minQty != 0 && maxQty != 0) {
                if (dtIncrementQty != 0) {
                    minQty = parseFloat(maxQty) + 1
                    maxQty = parseFloat(maxQty) + parseFloat(dtIncrementQty)
                }
            }
            if (diskperAct) {
                incDiscPer = parseFloat(parseFloat(incDiscPer) + parseFloat(dtIncrementDescPer)).toFixed(2)
            }
            if (diskamtAct) {
                incDiscAmount = parseFloat(parseFloat(incDiscAmount) + parseFloat(dtIncrementalDiscount)).toFixed(2)
            }

            if (fskbidAct) {
                incFreeQty = parseFloat(parseFloat(incFreeQty) + parseFloat(dtFreeIssueIncreQty))
            }

            if (vouAct) {
                incVoucherQty = parseInt(parseInt(incVoucherQty) + parseInt(INCVOUQTY))
            }

            if (pointAct) {
                incPoints = parseInt(parseInt(incPoints) + parseInt(INCPOINTS))
            }

            if (ticketAct) {
                incTickrtQty = parseInt(parseInt(incTickrtQty) + parseInt(INCTICKQTY))
            }

            if (minVal != 0 && maxVal != 0) {
                if (dtIncrementalValue != 0) {
                    // if (parseFloat(maxVal) % 1 != 0) {
                    //     minVal = parseFloat(Math.ceil(maxVal)).toFixed(2)
                    //     maxVal = parseFloat(parseFloat(maxVal) + parseFloat(dtIncrementalValue)).toFixed(2)
                    // } else {
                    //     minVal = parseFloat(maxVal) + 1
                    //     maxVal = parseFloat(parseFloat(maxVal) + parseFloat(dtIncrementalValue)).toFixed(2)
                    // }
                    minVal = parseFloat(maxVal).toFixed(2)
                    maxVal = parseFloat(parseFloat(maxVal) + parseFloat(dtIncrementalValue)).toFixed(2)

                }
            }
        }
        setProDetailsTable(newTable)
    }

    function RowAdd() {
        var newList = [...ProDetailsTable]
        newList.push({
            "id": ProDetailsTable.length + 1,
            "QtyFrom": dtMinQty,
            "QtyTo": dtMaxQty,
            "ValueFrom": parseFloat(dtMinValue).toFixed(2),
            "ValueTo": parseFloat(dtMaxValue).toFixed(2),
            "DiscPer": parseFloat(dtDiscPer).toFixed(2),
            "DiscValue": parseFloat(dtDiscountAmount).toFixed(2),
            "freeQty": dtFreeIssueQty,
            "TicketQty": dtTicket,
            "VoucherQty": VOUQTY,
            "VoucherValue": VOUVALUE,
            "Points": POINTS,
            "validQty": 0,
            "OfferBun": itemBundle,
            "GroupBun": itemBundle,
            "FreeItem": allSkubundles,
        })
        setProDetailsTable(newList)
    }

    function handleRemoveRow(id, key) {
        var newList = []
        for (var i = 0; i < ProDetailsTable.length; i++) {
            if (i !== key) {
                newList.push(ProDetailsTable[i])
            }
        }
        setProDetailsTable(newList)
    }


    function handleRowChange(name, key, value) {
        var newList = [...ProDetailsTable]
        newList[key][name] = value
        setProDetailsTable(newList)
    }


    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={12} className="mb-4-sm">

                    {showAllFields && pskubidAct ? <Row className="mb-0">
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Offer Bundle</Label>
                        </Col>
                        <Col sm={12} md={5}>
                            <DPDropDown
                                selectedGroup={itemBundle}
                                onChange={setItemBundle}
                                optionGroup={allSkubundles}
                                labelText={'Offer Bundle'}
                                disabled={disabled}
                                labelHide={true}
                            />
                        </Col>

                    </Row> : null}
                    {showAllFields && grpbidAct ? <Row className="mb-0">
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Group Bundled</Label>
                        </Col>
                        <Col sm={12} md={5}>
                            <DPDropDown
                                selectedGroup={groupBundle}
                                onChange={setGroupBundle}
                                optionGroup={allSKUGrpBundles}
                                labelText={'Group Bundled'}
                                disabled={disabled}
                                labelHide={true}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Minimum</Label>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Qty</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtMinQty}
                                onChange={SetdtMinQty}
                                textAlign={"right"}
                                disabled={disabled ? true : disbleQty}
                                onBlur={SetdtMinQtyOnBlur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Value</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtMinValue}
                                onChange={SetdtMinValue}
                                textAlign={"right"}
                                disabled={disabled ? true : disbleValue}
                                onBlur={SetdtMinValueOnBlur}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Maximum</Label>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Qty</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtMaxQty}
                                onChange={SetdtMaxQty}
                                textAlign={"right"}
                                disabled={disabled ? true : disbleQty}
                                onBlur={SetdtMaxQtyOnBlur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Value</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtMaxValue}
                                onChange={SetdtMaxValue}
                                textAlign={"right"}
                                disabled={disabled ? true : disbleValue}
                                onBlur={SetdtMaxValueOnBlur}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        {diskperAct || diskamtAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Discount</Label>
                        </Col> : null}
                        {diskperAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Percentage</Label>
                        </Col> : null}
                        {diskperAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtDiscPer}
                                onChange={SetdtDiscPer}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtDiscPerOnBlur}
                            />
                        </Col> : null}

                        {diskamtAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Value</Label>
                        </Col> : null}
                        {diskamtAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtDiscountAmount}
                                onChange={SetdtDiscountAmount}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtDiscountAmountOnBlur}
                            />
                        </Col> : null}

                    </Row> : null}

                    {showAllFields && fskbidAct ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Free</Label>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Qty</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtFreeIssueQty}
                                onChange={SetdtFreeIssueQty}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtFreeIssueQtyOnBlur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Item</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPDropDown
                                labelHide={true}
                                labelText="Item"
                                rowClass="mb-4-sm"
                                optionGroup={allSkubundles}
                                selectedGroup={freeIssueItem}
                                onChange={freeItemOnchange}
                                disabled={disabled}
                            />
                        </Col>

                    </Row> : null}

                    {showAllFields && vouAct ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Voucher</Label>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Qty</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={VOUQTY}
                                onChange={setVOUQTY}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setVOUQTYOnBlur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Value</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={VOUVALUE}
                                onChange={setVOUVALUE}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setVOUVALUEOnBlur}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        {ticketAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Ticket</Label>
                        </Col> : null}
                        {ticketAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Qty</Label>
                        </Col> : null}
                        {ticketAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtTicket}
                                onChange={SetdtTicket}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtTicketOnBlur}
                            />
                        </Col> : null}
                        {ticketAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>ID</Label>
                        </Col> : null}
                        {ticketAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPDropDown
                                labelHide={true}
                                labelText="Ticket"
                                rowClass="mb-4-sm"
                                optionGroup={TicketSet}
                                selectedGroup={Ticket}
                                onChange={setTicket}
                                disabled={disabled}
                            />
                        </Col> : null}
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        {pointAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Points</Label>
                        </Col> : null}
                        {pointAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}></Label>
                        </Col> : null}
                        {pointAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={POINTS}
                                onChange={setPOINTS}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setPOINTSOnBlur}
                            />
                        </Col> : null}
                    </Row> : null}

                    {showAllFields ? <hr></hr> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Incremental</Label>
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Qty</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtIncrementQty}
                                onChange={SetdtIncrementQty}
                                textAlign={"right"}
                                disabled={disabled ? true : disableList.Quantity}
                                onBlur={SetdtIncrementQtyOnBlur}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Value</Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtIncrementalValue}
                                onChange={SetdtIncrementalValue}
                                textAlign={"right"}
                                disabled={disabled ? true : disableList.Value}
                                onBlur={SetdtIncrementalValueOnBlur}
                            />
                        </Col>
                        {diskperAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Disc.Per</Label>
                        </Col> : null}
                        {diskperAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtIncrementDescPer}
                                onChange={SetdtIncrementDescPer}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtIncrementDescPerOnBlur}
                            />
                        </Col> : null}

                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}></Label>
                        </Col>
                        {diskamtAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Disc.Amount</Label>
                        </Col> : null}
                        {diskamtAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtIncrementalDiscount}
                                onChange={SetdtIncrementalDiscount}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtIncrementalDiscountOnBlur}
                            />
                        </Col> : null}
                        {fskbidAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Free Qty</Label>
                        </Col> : null}
                        {fskbidAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={dtFreeIssueIncreQty}
                                onChange={SetdtFreeIssueIncreQty}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={SetdtFreeIssueIncreQtyOnBlur}
                            />
                        </Col> : null}
                        {ticketAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Ticket Qty</Label>
                        </Col> : null}
                        {ticketAct ? < Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={INCTICKQTY}
                                onChange={setINCTICKQTY}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setINCTICKQTYOnBlur}
                            />
                        </Col> : null}
                    </Row> : null}

                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}></Label>
                        </Col>
                        {vouAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Voucher Qty</Label>
                        </Col> : null}
                        {vouAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={INCVOUQTY}
                                onChange={setINCVOUQTY}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setINCVOUQTYOnBlur}
                            />
                        </Col> : null}
                        {pointAct ? <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Points</Label>
                        </Col> : null}
                        {pointAct ? <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={INCPOINTS}
                                onChange={setINCPOINTS}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setINCPOINTSOnBlur}
                            />
                        </Col> : null}
                    </Row> : null}


                    {showAllFields ? <Row className="mb-0">
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}>Incremental Rounds
                            </Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={INCROUNDS}
                                onChange={setINCROUNDS}
                                textAlign={"right"}
                                disabled={disabled}
                                onBlur={setINCROUNDSOnBlur}
                            />
                        </Col>
                    </Row> : null}

                    {showAllFields ? <Row className="mb-2" style={{ display: "grid", gridTemplateColumns: "auto auto", gap: '1em' }}>

                        <Button color="primary" className="mr-1" style={{ marginLeft: "2px", marginRight: "2px" }} disabled={disabled} onClick={() => {
                            IncrementalCreate()
                        }}>
                            <i className="fa fa-plus"></i> Incremental Add
                        </Button>

                        <Button color="success" className="mr-1" style={{ marginLeft: "2px", marginRight: "2px" }} disabled={disabled} onClick={() => {
                            RowAdd()
                        }}>
                            <i className="fa fa-plus"></i> Row Add
                        </Button>
                    </Row> : null}
                </Col>

                <Col sm={12} md={12} className="mb-4-sm">

                    <table className="custom-table table-bordered table-sm rounded" >
                        <thead className='table-secondary'>
                            <tr>
                                <th>Qty From </th>
                                <th>Qty To </th>
                                <th>Value From </th>
                                <th>Value To </th>
                                {showAllFields && pskubidAct ? <th>Offer Bundle</th> : null}
                                <th>Disc.Per </th>
                                <th>Disc.Amount </th>
                                <th>Free Qty </th>
                                <th>Ticket Qty </th>
                                <th>Voucher Qty </th>
                                <th>Voucher Value </th>
                                <th>Points </th>
                                <th>Valid Qty </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(ProDetailsTable || []).map((item, index) => {
                                return (
                                    <TableRow
                                        FormRow={item}
                                        Key={index}
                                        handleRemoveRow={handleRemoveRow}
                                        Disabled={disabled}
                                        handleRowChange={handleRowChange}
                                        showAllFields={showAllFields}
                                        pskubidAct={pskubidAct}
                                        allSkubundles={allSkubundles}
                                        disableList={disableList}
                                    />
                                )
                            })}
                        </tbody>
                    </table>
                </Col>
            </Row >

        </React.Fragment >
    )

}


const TableRow = ({ FormRow, Key, handleRowChange, Disabled, handleRemoveRow, showAllFields, pskubidAct, allSkubundles, disableList }) => {

    return (
        <tr key={Key} className="no-hover no-pointer">
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"QtyFrom" + Key}
                    value={FormRow.QtyFrom}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("QtyFrom", Key, value)
                        } else {
                            handleRowChange("QtyFrom", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Quantity}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("QtyFrom", Key, 0)
                        } else {
                            handleRowChange("QtyFrom", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"QtyTo" + Key}
                    value={FormRow.QtyTo}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("QtyTo", Key, value)
                        } else {
                            handleRowChange("QtyTo", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Quantity}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("QtyTo", Key, 0)
                        } else {
                            handleRowChange("QtyTo", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"ValueFrom" + Key}
                    value={FormRow.ValueFrom}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("ValueFrom", Key, value)
                        } else {
                            handleRowChange("ValueFrom", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Value}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("ValueFrom", Key, 0)
                        } else {
                            handleRowChange("ValueFrom", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"ValueTo" + Key}
                    value={FormRow.ValueTo}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("ValueTo", Key, value)
                        } else {
                            handleRowChange("ValueTo", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Value}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("ValueTo", Key, 0)
                        } else {
                            handleRowChange("ValueTo", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            {showAllFields && pskubidAct ? <td style={{ width: "150px" }}>
                <DPDropDown
                    selectedGroup={FormRow.OfferBun}
                    onChange={(e) => {
                        handleRowChange("OfferBun", Key, e["value"])
                    }}
                    optionGroup={allSkubundles}
                    labelHide={true}
                    disabled={Disabled}
                />
            </td> : null}
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"DiscPer" + Key}
                    value={FormRow.DiscPer}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("DiscPer", Key, value)
                        } else {
                            handleRowChange("DiscPer", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.DiscountPercentage}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("DiscPer", Key, 0)
                        } else {
                            handleRowChange("DiscPer", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"DiscValue" + Key}
                    value={FormRow.DiscValue}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("DiscValue", Key, value)
                        } else {
                            handleRowChange("DiscValue", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.DiscountAmount}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("DiscValue", Key, 0)
                        } else {
                            handleRowChange("DiscValue", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"freeQty" + Key}
                    value={FormRow.freeQty}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("freeQty", Key, value)
                        } else {
                            handleRowChange("freeQty", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.FreeQty}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("freeQty", Key, 0)
                        } else {
                            handleRowChange("freeQty", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"TicketQty" + Key}
                    value={FormRow.TicketQty}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 0, false, false)
                        if (value != "") {
                            handleRowChange("TicketQty", Key, value)
                        } else {
                            handleRowChange("TicketQty", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Ticket}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("TicketQty", Key, 0)
                        } else {
                            handleRowChange("TicketQty", Key, DecimalValidation(parseInt(e.target.value, 10)))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"VoucherQty" + Key}
                    value={FormRow.VoucherQty}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 0, false, false)
                        if (value != "") {
                            handleRowChange("VoucherQty", Key, value)
                        } else {
                            handleRowChange("VoucherQty", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Voucher}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("VoucherQty", Key, 0)
                        } else {
                            handleRowChange("VoucherQty", Key, DecimalValidation(parseInt(e.target.value, 10)))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"VoucherValue" + Key}
                    value={FormRow.VoucherValue}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("VoucherValue", Key, value)
                        } else {
                            handleRowChange("VoucherValue", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Voucher}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("VoucherValue", Key, 0)
                        } else {
                            handleRowChange("VoucherValue", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"Points" + Key}
                    value={FormRow.Points}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("Points", Key, value)
                        } else {
                            handleRowChange("Points", Key, 0)
                        }
                    }}
                    disabled={Disabled ? true : disableList.Point}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("Points", Key, 0)
                        } else {
                            handleRowChange("Points", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    textAlign={"right"}
                    id={"validQty" + Key}
                    value={FormRow.validQty}
                    onChange={(e) => {
                        var value = Numeric(e.target, 8, 2, false, false)
                        if (value != "") {
                            handleRowChange("validQty", Key, value)
                        } else {
                            handleRowChange("validQty", Key, 0)
                        }
                    }
                    }
                    disabled={Disabled ? true : disableList.Quantity}
                    onBlur={(e) => {
                        if (e.target.value == "") {
                            handleRowChange("validQty", Key, 0)
                        } else {
                            handleRowChange("validQty", Key, DecimalValidation(e.target.value, 0, true, 2))
                        }
                    }}
                />
            </td>
            <td>
                <Button
                    outline
                    color="danger"
                    disabled={Disabled}
                    onClick={() => {
                        handleRemoveRow(FormRow.id, Key)
                    }}
                    size="sm"
                >
                    <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
                </Button></td>

        </tr>

    )

}


export default PromotionDetailsContent